<!--  eslint-disable @angular-eslint/template/no-negated-async -->
<era-panel>
  <ml-sk-spinner-3 [hidden]="(app$ | async) || !(bundleId$ | async)"></ml-sk-spinner-3>

  @if (app$ | async; as app) {
    <ml-mdm-apple-app [app]="app"></ml-mdm-apple-app>
  } @if (!(bundleId$ | async)) {
    <div class="d-flex h-100 align-items-start">
      <p class="text-center text-muted p-4">Please select an app from the list.</p>
    </div>
  } @if (app$ | async; as app) {
    <era-panel-footer>
      @if (udid$ | async; as udid) {
        <div class="btn-toolbar flex-row-reverse p-1 bg-gray-100 border-top">
          <ml-mdm-command-spinner [commandProgress]="removeAppProgress$"
                                  [small]="true"
                                  [direction]="'right'"
                                  [reverse]="true"
                                  class="flex-grow-1 text-end">
            <button type="button"
                    (click)="remove(udid, app)"
                    class="btn btn-outline-primary border-0">
              <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
            </button>
          </ml-mdm-command-spinner>
          <button class="btn btn-outline-primary border-0"
                  (click)="showAppLockModal(app, udid)">
            <fa-icon icon="lock"></fa-icon>
          </button>
        </div>
      }
    </era-panel-footer>
  }
</era-panel>